import React, { useEffect } from "react"
import { AppAntSwitch } from "@components"
import { reportFormData, useOfficePickup } from "Pages/ReportsAlerts/Reports/@signals"


export default function OfficeSwitch() {


	useEffect(() => {
		useOfficePickup.value = !!reportFormData.peek().idOfficeGroup?.length
	}, [])

	return <AppAntSwitch
		trueText="Use Office Group"
		checked={useOfficePickup.value}
		onChange={() => useOfficePickup.value = !useOfficePickup.value}
	/>
}